import Utils from './oss.util'
import {
  environment
} from './oss.env'
import {
  axios
} from './request.js'
import Vue from 'vue'
// import store from '@/store/index'
class OssService {
  Initialization() {
    const that = this
    return new Promise(function (resolve, reject) {
      // 华为
      that.initByHuawei().then((res) => {
        resolve(res)
      })
    })
  }
  /**
   * 华为OBS初始化
   */
  initByHuawei() {
    const that = this
    return new Promise((resolve, reject) => {
      axios.get(that.getResUrl() + '&source=huawei').then(result => {
        if (result.code === '1') {
          const msg = result.credential
          if (msg) {
            // expires_at：过期时间(UTC通用标识时间)
            // access：ak
            // secret：sk
            // securitytoken：用于后续换SK、 Token或loginToken使用
            that.obs = {
              ak: msg.access,
              sk: msg.secret,
              times: msg.expires_at,
              token: msg.securitytoken
            }
            Utils.putClint(result)
            resolve(200)
          } else {
            reject(result, '初始化失败')
          }
        }
      }, errpr => {})
    })
  }

  getResUrl() {
    // sts获取授权令牌
    const res = environment.ossRes
    // 层级
    const url = environment.ossHierarchy
    // 加密盐
    const key = 'FOyXP4hrDTz4Ja18EC3ux4cVvDEJZq'
    // BucketName
    const code = environment.ossBucketName
    // 令牌token
    const stsInfo = 'code=' + code + '&url=' + url
    const sign = Utils.md5Str(stsInfo + key)
    return res + stsInfo + '&sign=' + sign
  }

  /**
   * ossurl:上传的oss具体路径
   * data:转化过的json字符串
   */
  ossput(ossurl, data, moduleId, detailId) {
    const that = this
    return new Promise(function (resolve, reject) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === moduleId) {
          data[i].detailId = detailId
          break
        }
      }
      Vue.ls.set('taskData', data)
      // console.log(store)
      if (data.legth === 0) {
        return
      }
      that.huaweiPutdataCheck(ossurl, data, moduleId, detailId).then((res) => {
        resolve(res)
      })
    })
  }

  /**
   * 华为上传前对鉴权时间检测
   */
  huaweiPutdataCheck(ossurl, data, moduleId, detailId) {
    const that = this
    return new Promise(function (resolve, reject) {
      // 获取缓存 华为clien
      const huweiClient = Utils.getClint()
      console.log(huweiClient)
      const ossTime = that.utc2beijing(huweiClient.credential.expires_at)
      console.log('上次获取时间:', ossTime)
      // 当前调用的时间
      // 比较时间超过限制就重新获取ossId
      const startTime = Date.parse(huweiClient.credential.expires_at)
      const newTime = Date.parse(new Date() + '')
      console.log(startTime, newTime)
      // const difftime = Math.abs((parseInt(startTime + '', 10) - parseInt(newTime + '', 10)) / 1000 / 60)
      // 相差超过 配置时间
      if (newTime >= startTime) {
        that.Initialization().then(() => {
          that.putHuaweiData(ossurl, data, moduleId, detailId).then((res) => {
            resolve(res)
          })
        })
      } else {
        that.putHuaweiData(ossurl, data, moduleId, detailId).then((res) => {
          resolve(res)
        })
      }
    })
  }

  /**
   *  华为上传具体方法
   * @param ossurl
   * @param data
   * @param moduleId
   * @param detailId
   */
  putHuaweiData(ossurl, data, moduleId, detailId) {
    const that = this
    return new Promise(function (resolve, reject) {
      const clientOss = Utils.getClint()
      const msg = clientOss.credential
      if (!msg) return
      that.obs = {
        ak: msg.access,
        sk: msg.secret,
        times: msg.expires_at,
        token: msg.securitytoken
      }
      const obsClient = new ObsClient({
        access_key_id: that.obs.ak,
        secret_access_key: that.obs.sk,
        server: environment.source_host,
      })
      obsClient.util.securityToken = that.obs.token
      // obsClient.initLog({
      //   level: 'debug', // 配置日志级别  查错用的，要用反注释就好
      // })

      const dataList = that.doOssData(data, moduleId, detailId)

      console.log('华为OBS 上传=>', ossurl)
      // 创建网络流
      obsClient.putObject({
        Bucket: environment.ossBucketName,
        Key: ossurl,
        Body: JSON.stringify(dataList)
      }, (err, result) => {
        if (err) {
          console.error('Error-->', err)
        } else {
          console.log('Status-->', result)
          resolve(result.CommonMsg.Status)
        }
      })
    })
  }

  /**
   * UTC时间转换
   */
  utc2beijing(utcDateTime) {
    // 2021-07-07T08:24:21.078000Z
    // 转为正常的时间格式 年-月-日 时:分:秒
    const tTops = utcDateTime.indexOf('T')
    const zPos = utcDateTime.indexOf('Z')
    const yearMonthDay = utcDateTime.substr(0, tTops)
    const hourMinuteSecond = utcDateTime.substr(tTops + 1, zPos - tTops - 1)
    const newDateTime = yearMonthDay + ' ' + hourMinuteSecond // 2017-03-31 08:02:06
    // 处理成为时间戳
    let timestamp = new Date(Date.parse(newDateTime)).getTime() / 1000
    // timestamp = timestamp.()
    // timestamp = timestamp / 1000
    // 增加8个小时，北京时间比utc时间多八个时区
    timestamp = timestamp + 8 * 60 * 60
    // 时间戳转为时间
    return new Date(timestamp * 1000).toLocaleString().replace(/年|月/g, '-').replace(/日/g, ' ')
  }

  // 处理data数据
  doOssData(data, moduleId, detailId) {
    const list = []
    if (data.length !== 0) {
      for (let i = 0; i < data.length; i++) {
        const child = {
          detailId: data[i].detailId,
          moduleId: data[i].id,
          seq: data[i].seq,
          isFinish: data[i].isFinish
        }
        if (data[i].id === moduleId) {
          child.detailId = detailId
          child.moduleId = data[i].id
          child.seq = data[i].seq
          child.isFinish = data[i].isFinish
        }
        list.push(child)
      }
      Vue.ls.set('detailData', list)
      // console.log(list)
      return list
    }
  }
}
export default new OssService()
